import { configureStore, createSlice } from "@reduxjs/toolkit";

const initialDevice = {
  token:"",
  LoggedIn: false
}

const deviceSlice = createSlice({
  name:"device",
  initialState:initialDevice,
  reducers:{
    loginDevice(state, action) {
      state.token =  action.payload.token;
      state.LoggedIn = true;
    },
    logoutDevice(state, action) {
      state.token = "";
      state.LoggedIn = false;
    }
  }
});

const urlSlice = createSlice({
  name:"url",
  initialState:{
    url:""
  },
  reducers:{
    setUrl(state, action) {
      state.url = action.payload;
    }
  }
});

export const {loginDevice, logoutDevice} = deviceSlice.actions;
export const {setUrl} = urlSlice.actions;
export const store = configureStore({
  reducer:{
    device: deviceSlice.reducer,
    url: urlSlice.reducer
  }
})
